<template>
<div class="grid grid-nogutter">
	<div class="col-12 " :id="'customattribute'+attribute.id" :class="inputfieldhightlight">

<!-- if no translations-->
	<template v-if="attribute.customattribute.type=='string'">
			<ClickEditInputText :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutetextval" :valkey="attribute.customattribute.id"  :read_only="attribute_editable" @dataChanged="attributeChanged"></ClickEditInputText>		
	</template>

	<template v-if="attribute.customattribute.type=='number'">
		<ClickEditNumber  :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" :read_only="attribute_editable"  @dataChanged="attributeChanged" />
	</template>

	<template v-if="attribute.customattribute.type=='boolean'">
		<ClickEditSwitch   :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id"  :read_only="attribute_editable" @dataChanged="attributeChanged" />
	</template>

	<template v-if="attribute.customattribute.type=='select'">
		<ClickEditSelect    :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id"  :read_only="attribute_editable" @dataChanged="attributeChanged"  :options="attribute.customattribute.options"   :color_selector="true" />	
	</template>

	<template v-if="attribute.customattribute.type=='multiselect'">
	<ClickEditMultiSelect  :title="getTheTranslation(attribute.customattribute,'translation')" :value="optionsformultiselect" :valkey="attribute.customattribute.id" @dataChanged="attributeChanged"  :options="attribute.customattribute.options" />    
	</template>




<!-- if no translations-->
</div>
</div>
</template>

<script>
export default {

  name: 'AuditCoverCustomattribute',
  props:["attribute"],
  data () {
    return {

    }
  },

  computed:{
  	optionsformultiselect()
    {
      if(this.attribute && this.attribute.customattribute.supplierattributes.length && this.attribute.customattribute.supplierattributes[0].attibutetextval)
      {
        let values =  JSON.parse(this.attribute.customattribute.supplierattributes[0].attibutetextval)

        let arr = []
        for(let value of values)
        {
          let ind = this.attribute.customattribute.options.findIndex((item=>item.id == value))
          if(ind !==-1)
          {
            arr.push(this.attribute.customattribute.options[ind])
          }
        }
        return arr
      }
      return []
      
    },
  	inputfieldhightlight()
  	{
  		if(this.$store.state.audit.missing_attribute)
  		{
  			if(this.attribute.is_required)
  			{

  				let submission = this.attribute.customattribute.supplierattributes[0]
				if(this.attribute.customattribute.type=="select" && !submission.attibutenumericalval)
				{
					return "inputfield_highlight"
				}
				else if(this.attribute.customattribute.type=="number" && !submission.attibutenumericalval)
				{
					return "inputfield_highlight"
				}
				else if(this.attribute.customattribute.type=="string" && !submission.attibutetextval)
				{
					return "inputfield_highlight"
				}
  				else
  				{
  					return ""
  				}
  				
  			}
  			return ""
  		}
  		return ""
  	},
  	attribute_editable()
  	{
  		let user = this.$store.state.auth.user
  		if(user.userroles && user.userroles.length)
  		{
  			let userroles = user.userroles.map((element)=>{return element.name})
  			if(userroles.includes("admin"))
  			{
  				return false
  			}
  			if(userroles.includes("planner") || userroles.includes("brand") || userroles.includes("supplier"))
  			{
  				return true
  			}
  			if(userroles.includes("auditor"))
  			{
  				if(this.$store.state.audit.audit.status=="finished")
  				{
  					return true
  				}
  				else
  				{
  					return false
  				}
  				
  			}
  		}
  		return true
  	},

  },
  methods:{
  	attributeChanged(data)
  	{
  		data.attributetype = this.attribute.customattribute.type
  		this.$emit("attributeChanged",data)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>